<template>
  <div id="page">
    <NavBar />

    <main class="row-height">
      <Errors :errors="errors" />
      <Alerts
        v-if="alertOptions.message"
        :alert-options="alertOptions"
      />
      <div class="container-fluid full-height">
        <div class="row">
          <!-- Mobile - blue bar on top of map -->
          <div class="col-12 content-left d-block d-lg-none">
            <div class="results_map_view mobile_results_map_view secondary_nav position-fixed">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <div v-if="storesList">
                      <strong>{{ storesList.length }}</strong>
                      {{ $t('lang.search.stores_found_in_this_area') }}
                    </div>
                    <div class="ml-auto">
                      <span v-if="showSearchForm">
                        {{ $t('lang.search.hide_search') }}
                      </span>
                      <span v-else>
                        {{ $t('lang.search.change_search') }}
                      </span>
                      <a
                        class="ml-2 search_mob btn_search_mobile map_view"
                        @click="showSearchForm = !showSearchForm"
                      />
                    </div>
                  </div>
                </div>

                <div
                  v-if="showSearchForm && isMobile"
                  id="input-search"
                  class="search_mob_wp"
                >
                  <div class="custom-search-input-2 map_view">
                    <SearchForm @searchFormSubmitted="searchStores" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 content-left order-md-last order-sm-last order-last">
            <!-- Blue bar on big screens -->
            <div class="results_map_view d-none d-lg-block">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12">
                    <h4
                      v-if="storesList"
                      class="float-left"
                    >
                      <strong>{{ storesList.length }}</strong>
                      {{ $t('lang.search.stores_found_in_this_area') }}
                    </h4>
                    <div class="float-right">
                      <span v-if="showSearchForm">
                        {{ $t('lang.search.hide_search') }}
                      </span>
                      <span v-else>
                        {{ $t('lang.search.change_search') }}
                      </span>
                      <a
                        class="ml-2 search_mob btn_search_mobile map_view"
                        @click="showSearchForm = !showSearchForm"
                      />
                    </div>
                  </div>
                </div>

                <div
                  v-if="showSearchForm && !isMobile"
                  id="input-search"
                  class="search_mob_wp"
                >
                  <div class="custom-search-input-2 map_view">
                    <SearchForm @searchFormSubmitted="searchStores" />
                  </div>
                </div>
              </div>
            </div>

            <div class="search_prices">
              <div class="container-fluid">
                <div class="">
                  <PriceInfo
                    :search-params="searchParams"
                    :order="order"
                    @orderChanged="updateOrder"
                  />
                </div>
              </div>
            </div>
            <p
              class="small mt-2 mb-0"
              v-html="$t('lang.search.prices.books_only')"
            />

            <EmptyResultsMessage
              v-if="showEmptyResults"
              class="bg-white text-center mt-3 mb-3 p-4"
            />

            <div
              v-if="showEmptySearchFormMessage"
              class="bg-white text-center mt-3 mb-3 p-4"
            >
              <div>
                <h6 class="mb-3">
                  {{ this.$t('lang.search.empty_search_form') }}
                </h6>
                <img
                  class="align-middle"
                  src="../assets/img/illustrations/search-stores.svg"
                  width="50%"
                  style="max-height: 200px"
                >
              </div>
            </div>

            <div v-if="!showStoreDetails">
              <StoreCardComponent
                v-for="store in orderedStoresList"
                :key="store.id"
                :store="store"
                :search-params="searchParams"
                :order="order"
                @selectedStoreCard="selectStore"
              />
            </div>

            <Errors
              v-if="(orderedStoresList === null ||
                orderedStoresList.length === 0) &&
                errors.length === 0"
              :errors="{ data_error: [this.$t('lang.search.empty_search_error')] }"
            />

            <StoreDetails
              v-if="showStoreDetails"
              :store="selectedStore"
              :search-params="searchParams"
              style="margin-top: 15px"
              @close="closeDetail"
              @bookingSubmitted="bookingSubmitted"
              @lockerSelectionChanged="lockersSelected"
            />

          <!--            <p-->
          <!--              v-if="!showStoreDetails"-->
          <!--              class="text-center add_top_30"-->
          <!--            >-->
          <!--              <a-->
          <!--                href="#"-->
          <!--                class="btn_1 rounded"-->
          <!--              ><strong>{{ $t('lang.search.load_more') }}</strong></a>-->
          <!--            </p>-->
          </div>
          <!-- /content-left-->

          <div class="col-lg-7 map-right mt-4 mt-lg-0">
            <MapComponent
              :key="mapKey"
              :place="selectedPlace"
              :stores-list="storesList"
              :selected-store-card="selectedStore"
              @selectedStoreMap="selectStore"
            />
          </div>
        </div>
      </div>
    </main>

    <b-modal
      id="empty-results-modal"
      hide-footer
      hide-header
      centered
      size="lg"
      content-class="p-3 text-center bg-light styled-modal"
    >
      <EmptyResultsMessage />

      <div class="new-modal-buttons">
        <button
          type="button"
          class="btn btn-dark mt-3 m-2"
          :title="$t('lang.search.search_again')"
          @click="$bvModal.hide('empty-results-modal')"
        >
          {{ $t('lang.search.search_again') }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PriceInfo from '@/components/Search/PriceInfo';
import Alerts from '@/components/Alerts/Alerts';
import EmptyResultsMessage from '@/components/Search/EmptyResultsMessage';
import NavBar from '../components/NavBar/NavBar';
import StoreCardComponent from '../components/Store/StoreCardComponent';
import SearchFilters from '../components/Search/SearchFilters';
import SearchForm from '../components/Search/SearchForm';
import MapComponent from '../components/Search/MapComponent';
import StoreDetails from '../components/Store/StoreDetails';

import { API, errorResponse } from '../api/api';
import Errors from '../components/Alerts/Errors';

import { cities } from '../data/cities';
import { getTrackingIds } from '@/utils/tracking';
import { getDefaultSearchDates } from '@/utils/dateFormatters';

const Search = API.get('search');
const Booking = API.get('booking');

export default {
  name: 'SearchStores',

  components: {
    EmptyResultsMessage,
    Alerts,
    Errors,
    NavBar,
    StoreCardComponent,
    SearchFilters,
    SearchForm,
    MapComponent,
    StoreDetails,
    PriceInfo,
  },

  data() {
    return {
      selectedPlace: {},
      searchParams: null,
      storesList: null,
      place: null,
      errors: {},
      showSearchForm: false,
      selectedStore: {},
      showStoreDetails: false,
      order: 'relevance',
      initialFilters: {
        open: 'all',
        recommended: false,
        less_than: false,
        distance: 1,
        category: 'all',
      },
      filters: {},
      filterValues: {},
      mapKey: 1,
      alertOptions: {},
      showEmptyResults: false,
      showEmptySearchFormMessage: false,
      lockers: [],
      openFirstResult: false,
    };
  },

  computed: {
    isMobile() {
      return window.innerWidth < 992;
    },

    // Payload object sent to API for search endpoint request
    searchPayload() {
      const { startDate, endDate } = this.getDatesFromSearchParams(this.searchParams);

      let latitudeCoordinate;
      let longitudeCoordinate;

      if (typeof this.searchParams.place.geometry.location.lat === 'function') {
        latitudeCoordinate = this.searchParams.place.geometry.location.lat();
        longitudeCoordinate = this.searchParams.place.geometry.location.lng();
      } else {
        latitudeCoordinate = this.searchParams.place.geometry.location.lat;
        longitudeCoordinate = this.searchParams.place.geometry.location.lng;
      }

      return {
        latitude_coordinate: latitudeCoordinate,
        longitude_coordinate: longitudeCoordinate,
        start_date: startDate,
        end_date: endDate,
        bags_number: this.searchParams.bags_number,
        currency: this.$store.state.main.currency ? this.$store.state.main.currency : 'USD',
        uuid: this.$store.state.main.uuid,
      };
    },

    // Payload object sent to API for search endpoint request
    newBookingPayload() {
      const { startDate, endDate } = this.getDatesFromSearchParams(this.searchParams);

      const payload = {
        store_id: this.selectedStore.id,
        start_date: startDate,
        end_date: endDate,
        bags_number: this.searchParams.bags_number,
        currency: this.$store.state.main.currency ? this.$store.state.main.currency : 'USD',
      };

      if (this.selectedStore.is_locker) {
        payload.lockers = this.lockers;
      }

      return payload;
    },

    orderedStoresList() {
      if (this.storesList) {
        const { filters } = this;
        let list = this.storesList;

        // FILTERS
        if (filters.open === 'open') {
          list = list.filter((store) => store.isAvailable);
        }
        if (filters.open === 'close') {
          list = list.filter((store) => store.isAvailable === false);
        }
        if (filters.recommended) {
          list = list.filter((store) => store.reputation_scoring >= 70);
        }
        if (filters.less_than) {
          list = list.filter((store) => store.distance <= filters.distance);
        }
        if (filters.category !== 'all') {
          list = list.filter((store) => store.category_id === filters.category);
        }

        // ORDER
        let listOpen = list.filter((store) => store.isAvailable);
        listOpen = listOpen.sort(this.compare);
        let listClose = list.filter((store) => store.isAvailable === false);
        listClose = listClose.sort(this.compare);

        list = listOpen.concat(listClose);
        return list;
      }
      return null;
    },
  },

  created() {
    const { newBookingData } = this.$store.state.search;
    if (newBookingData && !this.$route.query['social-network-auth']) {
      this.newBooking(newBookingData);
      this.$store.dispatch('removeNewBookingData');
    }
    this.filters = JSON.parse(JSON.stringify(this.initialFilters));

    this.findSearchParams('created');

    this.selectedPlace = null;
    if (this.searchParams != null) {
      this.selectedPlace = this.searchParams.place;
      this.searchStores(this.selectedPlace, 'created');
    } else {
      this.showSearchForm = true;
      this.showEmptySearchFormMessage = true;
    }
  },

  methods: {
    findSearchParams(action) {
      let searchParams = null;
      const { query } = this.$route;

      if (query.open_first == 'true') {
        this.openFirstResult = true;
      }

      // only when the page is created for the first time data is loaded from url
      // if it has params and doesn't have /city_id, no need to decode data
      // if it has /city_id is processed on the mounted of SearchForm

      if (!this.$route.params.city_id && action === 'created'
          && query.lat && query.lng) {
        // for special URL with lat, lng and specific address
        searchParams = this.getSearchParamsFromCoordinatesQuery(query);
        this.$store.dispatch('setSearchParams', searchParams);
      } else if (!this.$route.params.city_id && action === 'created'
          && query.y && query.x && query.start_date && query.end_date) {
        searchParams = {
          place: {
            geometry: {
              location: {
                lat: parseFloat(query.y) / 1000,
                lng: parseFloat(query.x) / 1000,
              },
            },
          },
          input_start_date: new Date(query.start_date).toISOString(),
          input_end_date: new Date(query.end_date).toISOString(),
          bags_number: query.bags_number ? query.bags_number : 2,
        };

        if (query.address) {
          searchParams.place.formatted_address = query.address;
        }

        this.$store.dispatch('setSearchParams', searchParams);
      } else if (!this.$route.params.city_id && this.$store.state.search.searchParams) {
        // When isn't page creation or url doesn't have parameters, the data is extracted from session storage.
        // Then sent it to the URL encoded.

        searchParams = this.$store.state.search.searchParams;

        let y;
        let x;
        // overwrite lat y long if has url only with coordinates - for external sellers
        if (query.lat && query.lng) {
          searchParams.place.geometry.location.lat = parseFloat(query.lat);
          searchParams.place.geometry.location.lng = parseFloat(query.lng);
          searchParams.place.formatted_address = this.$t('lang.search.my_location');
        }

        if (typeof searchParams.place.geometry.location.lat === 'function') {
          y = searchParams.place.geometry.location.lat();
          x = searchParams.place.geometry.location.lng();
        } else {
          y = searchParams.place.geometry.location.lat;
          x = searchParams.place.geometry.location.lng;
        }
        y *= 1000;
        x *= 1000;

        // replace - with / on dates or it doesn't work in safari
        const startDate = this.formatDate(searchParams.input_start_date).replace(/-/g, '/').replace('T', ' ');
        const endDate = this.formatDate(searchParams.input_end_date).replace(/-/g, '/').replace('T', ' ');
        const bagsNumber = searchParams.bags_number;

        let newUrl = `/${this.$store.state.main.lang}/search?`;
        newUrl += `y=${encodeURIComponent(y)}`;
        newUrl += `&x=${encodeURIComponent(x)}`;
        newUrl += `&start_date=${encodeURIComponent(startDate)}`;
        newUrl += `&end_date=${encodeURIComponent(endDate)}`;
        newUrl += `&bags_number=${encodeURIComponent(bagsNumber)}`;

        if (searchParams.place.formatted_address) {
          newUrl += `&address=${encodeURI(searchParams.place.formatted_address)}`;
          // only encodeURI because encodeURIComponent transforms the ','
          // that aren't needed and then breaks the next if
        }

        // Avoid Error: redundant navigation to current location
        if (this.$router.currentRoute.fullPath !== newUrl) {
          this.$router.push(newUrl);
        }
      } else if (!this.$route.params.city_id) {
        this.showSearchForm = true;
        this.showEmptySearchFormMessage = true;
      }
      this.searchParams = searchParams;
    },

    getSearchParamsFromCoordinatesQuery(query) {
      const defaultDates = getDefaultSearchDates();
      const startDate = query.start_date
        ? new Date(query.start_date)
        : defaultDates.startDate;
      const endDate = query.end_date
        ? new Date(query.end_date)
        : defaultDates.endDate;

      const searchParams = {
        place: {
          geometry: {
            location: {
              lat: parseFloat(query.lat),
              lng: parseFloat(query.lng),
            },
          },
        },
        input_start_date: startDate,
        input_end_date: endDate,
        bags_number: query.bags_number ? query.bags_number : 2,
      };

      searchParams.place.formatted_address = query.address
        ? query.address
        : this.$t('lang.search.my_location');

      return searchParams;
    },

    getDatesFromSearchParams(searchParams) {
      const startDate = this.formatDate(searchParams.input_start_date);
      const endDate = this.formatDate(searchParams.input_end_date);

      return { startDate, endDate };
    },

    formatDate(inputDate) {
      const date = new Date(inputDate);
      return `${date.getFullYear()}-${
        (`00${date.getMonth() + 1}`).slice(-2)}-${
        (`00${date.getDate()}`).slice(-2)} ${
        (`00${date.getHours()}`).slice(-2)}:${
        (`00${date.getMinutes()}`).slice(-2)}:${
        (`00${date.getSeconds()}`).slice(-2)}`;
    },

    compare(storeA, storeB) {
      let difference;

      if (this.order === 'relevance') {
        const relevanceScoreA = storeA.relevance_score;
        const relevanceScoreB = storeB.relevance_score;

        difference = relevanceScoreB - relevanceScoreA;
      }
      if (this.order === 'distance') {
        const distanceA = storeA.distance;
        const distanceB = storeB.distance;

        difference = distanceA - distanceB;
      }

      return difference;
    },

    async searchStores(place, source = 'updated') {
      // cookies consent
      if (!this.$store.state.main.acceptedCookies) {
        window.gtag('consent', 'update', {
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          analytics_storage: 'granted',
        });

        dataLayer.push({
          event: 'cookie_consent',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          ad_storage: 'granted',
          analytics_storage: 'granted',
        });
        this.$store.dispatch('setCookiesConfig', true);
      }

      this.closeDetail();
      this.errors = {};
      this.showEmptyResults = false;
      this.showEmptySearchFormMessage = false;

      this.mapKey++; // reload map component with new search

      try {
        this.selectedPlace = place;
        if (source === 'updated') {
          this.findSearchParams('updated');
        }

        const { data } = await Search.getSearchResults(this.searchPayload);

        if (data.currency !== this.$store.state.main.currency) {
          this.alertOptions = {
            message: this.$t('lang.search.search_currency_changed'),
            variant: 'default',
          };
          this.$store.dispatch('setCurrency', data.currency);
        }
        this.storesList = data.results;

        // GTAG Event
        dataLayer.push({
          event: 'search',
        });

        if (this.storesList.length === 0) {
          this.showSearchForm = true;
          this.showEmptyResults = true;
          this.$bvModal.show('empty-results-modal');
        } else {
          this.showSearchForm = false;
          this.calculateFilterValues();
          this.showAlerts();
          this.setOrder();
          this.openFirstStoreResult();
        }
      } catch (error) {
        this.errors = errorResponse(error);
      }
      window.scrollTo(0, 0);
    },

    async newBooking(payload) {
      if (this.$store.state.main.token) {
        try {
          // add tracking ids for payment return url
          payload.data = getTrackingIds();
          const { data } = await Booking.newBooking(payload);

          if (data) {
            // GTAG Event
            dataLayer.push({
              event: 'add_to_cart',
              booking_id: data.id,
              user_id: data.user_id,
              value: data.total_price,
              currency: data.currency,
              bags_number: data.bags_number,
              // email: data.user.email, todo: add in data
            });

            this.$router.push(`/${this.$store.state.main.lang}/bookings/${data.id}`);
          }
        } catch (error) {
          this.errors = errorResponse(error);

          if (error.response.status === 401) {
            // Set new booking data, to make the booking after auth
            await this.$store.dispatch('setNewBookingData', payload);
            await this.$store.dispatch('setAuthToShow', 'register');
            this.$root.$emit('bv::show::modal', 'authModal');
            // GTAG Event
            dataLayer.push({
              event: 'open_auth_modal',
              source: 'search',
            });
          }
        }
      } else {
        await this.$store.dispatch('setNewBookingData', payload);
        await this.$store.dispatch('setAuthToShow', 'register');
        this.$root.$emit('bv::show::modal', 'authModal');
        // GTAG Event
        dataLayer.push({
          event: 'open_auth_modal',
          source: 'search',
        });
      }
    },

    bookingSubmitted(storeBookingAdjustment = null) {
      if (storeBookingAdjustment && storeBookingAdjustment.startDate) {
        this.searchParams.input_start_date = storeBookingAdjustment.startDate;
        this.searchParams.input_end_date = storeBookingAdjustment.endDate;
        this.$store.dispatch('setSearchParams', this.searchParams);
      }
      if (storeBookingAdjustment && storeBookingAdjustment.currency) {
        this.$store.dispatch('setCurrency', storeBookingAdjustment.currency);
      }

      this.newBooking(this.newBookingPayload);
    },

    selectStore(store, source) {
      this.selectedStore = store;
      this.showStoreDetails = true;

      // // GTAG Event
      dataLayer.push({
        event: 'store_selected_from_map',
        store_id: store.id,
        store_isAvailable: store.isAvailable,
        source,
      });
    },

    openFirstStoreResult() {
      if (!this.openFirstResult || !this.orderedStoresList || this.orderedStoresList.length === 0) {
        return;
      }

      const firstStore = this.orderedStoresList[0];
      this.openFirstResult = false;
      this.selectStore(firstStore, 'open_first');
    },

    closeDetail() {
      this.selectedStore = null;
      this.showStoreDetails = false;
    },

    updateOrder(order) {
      this.order = order;
    },

    updateFilters(filters) {
      this.filters = JSON.parse(JSON.stringify(filters));
    },

    emptyFilters() {
      this.filters = JSON.parse(JSON.stringify(this.initialFilters));
    },

    calculateFilterValues() {
      const list = this.storesList;
      this.$set(this.filterValues, 'open', list.filter((store) => store.isAvailable).length);
      this.$set(this.filterValues, 'close', list.filter((store) => store.isAvailable === false).length);
      this.$set(this.filterValues, 'recommended', list.filter((store) => store.reputation_scoring >= 70).length);

      for (const category in this.$globalCategories) {
        this.$set(this.filterValues,
          category,
          list.filter((store) => store.category_id === category).length);
      }
    },

    showAlerts() {
      if (this.filterValues.open === 0) {
        this.showSearchForm = true;
        this.errors = { data_error: [this.$t('lang.search.nothing_available')] };
      }

      // let schedule = 0;
      // let currency = 0;
      //
      // for (let i = 0; i < 5; i++) {
      //   schedule += (this.storesList.filter((store) => store.reason_closed[i] === 'schedule').length);
      //   currency += (this.storesList.filter((store) => store.reason_closed[i] === 'currency').length);
      // }
      //
      // if (this.filterValues.open < (this.storesList.length * 0.4)) {
      //   if (schedule > currency) {
      //     this.alertMessages = this.$t('lang.search.change_schedule');
      //   } else {
      //     this.alertMessages = this.$t('lang.search.change_currency');
      //   }
      // }
    },

    setOrder() {
      const searchData = this.searchPayload;
      let newOrder = 'distance';

      try {
        const cityLat = cities.find((data) => data.geometry.location.lat === searchData.latitude_coordinate).id;
        const cityLng = cities.find((data) => data.geometry.location.lng === searchData.longitude_coordinate).id;
        if (cityLat && cityLng && (cityLat === cityLng)) {
          newOrder = 'relevance';
        }
      } catch (e) {
        // nada
      }
      this.order = newOrder;
    },

    lockersSelected(data) {
      this.lockers = data;
    },
  },
};

</script>

<style scoped>
/*Only on this the error alert doesnt need margin bottom*/
.alert{
    margin-bottom: 0;
}

.mobile_results_map_view{
  min-height: 20px;
  font-size: .85rem;
  width: 100%;
  padding: 10px 0px;
}
</style>
